import React from 'react'
import { Mail, Linkedin, Award, Briefcase } from 'lucide-react'

const Team = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Anu Mishra',
      role: 'Founder & Principal Designer',
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&q=80',
      bio: 'With over 15 years of experience in interior design, Anu brings a unique blend of creativity and functionality to every project. Her passion for transforming spaces has earned her numerous accolades in the industry.',
      email: 'anu@mishradesigns.com',
      linkedin: '#',
      specialization: 'Luxury Residential & Commercial Design',
      experience: '15+ years'
    },
    {
      id: 2,
      name: 'Rahul Verma',
      role: 'Senior Interior Designer',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=600&q=80',
      bio: 'Rahul specializes in contemporary commercial spaces and has led numerous high-profile office redesign projects. His innovative approach to workspace design has transformed how companies think about their environments.',
      email: 'rahul@mishradesigns.com',
      linkedin: '#',
      specialization: 'Commercial & Workspace Design',
      experience: '10+ years'
    },
    {
      id: 3,
      name: 'Priya Kapoor',
      role: 'Design Consultant',
      image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=600&q=80',
      bio: 'Priya brings expertise in sustainable design and eco-friendly materials. She ensures that every project not only looks beautiful but also minimizes environmental impact.',
      email: 'priya@mishradesigns.com',
      linkedin: '#',
      specialization: 'Sustainable Design & Green Architecture',
      experience: '8+ years'
    },
    {
      id: 4,
      name: 'Arjun Malhotra',
      role: 'Project Manager',
      image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=600&q=80',
      bio: 'Arjun ensures seamless execution of all projects from concept to completion. His meticulous attention to detail and excellent coordination skills keep projects on time and within budget.',
      email: 'arjun@mishradesigns.com',
      linkedin: '#',
      specialization: 'Project Management & Execution',
      experience: '12+ years'
    },
    {
      id: 5,
      name: 'Neha Sharma',
      role: 'Interior Stylist',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=600&q=80',
      bio: 'Neha has an exceptional eye for color, texture, and accessories. She adds the perfect finishing touches that bring each space to life and reflect the client\'s personality.',
      email: 'neha@mishradesigns.com',
      linkedin: '#',
      specialization: 'Styling & Space Curation',
      experience: '7+ years'
    },
    {
      id: 6,
      name: 'Vikram Singh',
      role: '3D Visualization Specialist',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&q=80',
      bio: 'Vikram creates stunning photorealistic renderings that help clients visualize their dream spaces before construction begins. His technical expertise bridges imagination and reality.',
      email: 'vikram@mishradesigns.com',
      linkedin: '#',
      specialization: '3D Rendering & Visualization',
      experience: '9+ years'
    }
  ]

  return (
    <div data-component-path="client/src/pages/Team.jsx" data-component-line="1:1" data-component-id="client/src/pages/Team.jsx:1:1" className="pt-20">
      <section data-component-path="client/src/pages/Team.jsx" data-component-line="2:3" data-component-id="client/src/pages/Team.jsx:2:3" className="py-20 bg-stone-50">
        <div data-component-path="client/src/pages/Team.jsx" data-component-line="3:5" data-component-id="client/src/pages/Team.jsx:3:5" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div data-component-path="client/src/pages/Team.jsx" data-component-line="4:7" data-component-id="client/src/pages/Team.jsx:4:7" className="text-center mb-12">
            <h1 data-component-path="client/src/pages/Team.jsx" data-component-line="5:9" data-component-id="client/src/pages/Team.jsx:5:9" className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 hero-title">Meet Our Team</h1>
            <p data-component-path="client/src/pages/Team.jsx" data-component-line="6:9" data-component-id="client/src/pages/Team.jsx:6:9" className="text-xl text-gray-600 max-w-3xl mx-auto">
              Talented professionals dedicated to bringing your vision to life with creativity, expertise, and passion
            </p>
          </div>

          <div data-component-path="client/src/pages/Team.jsx" data-component-line="7:7" data-component-id="client/src/pages/Team.jsx:7:7" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member) => (
              <div data-component-path="client/src/pages/Team.jsx" data-component-line="8:9" data-component-id="client/src/pages/Team.jsx:8:9"
                key={member.id}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
              >
                <div data-component-path="client/src/pages/Team.jsx" data-component-line="9:11" data-component-id="client/src/pages/Team.jsx:9:11" className="relative h-80 overflow-hidden">
                  <img data-component-path="client/src/pages/Team.jsx" data-component-line="10:13" data-component-id="client/src/pages/Team.jsx:10:13"
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&q=80'
                    }}
                  />
                  <div data-component-path="client/src/pages/Team.jsx" data-component-line="11:13" data-component-id="client/src/pages/Team.jsx:11:13" className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                  <div data-component-path="client/src/pages/Team.jsx" data-component-line="12:13" data-component-id="client/src/pages/Team.jsx:12:13" className="absolute bottom-4 left-4 right-4 text-white">
                    <h3 data-component-path="client/src/pages/Team.jsx" data-component-line="13:15" data-component-id="client/src/pages/Team.jsx:13:15" className="text-2xl font-bold mb-1 hero-title">{member.name}</h3>
                    <p data-component-path="client/src/pages/Team.jsx" data-component-line="14:15" data-component-id="client/src/pages/Team.jsx:14:15" className="text-amber-400 font-medium">{member.role}</p>
                  </div>
                </div>

                <div data-component-path="client/src/pages/Team.jsx" data-component-line="15:11" data-component-id="client/src/pages/Team.jsx:15:11" className="p-6">
                  <p data-component-path="client/src/pages/Team.jsx" data-component-line="16:13" data-component-id="client/src/pages/Team.jsx:16:13" className="text-gray-600 mb-4 leading-relaxed">{member.bio}</p>

                  <div data-component-path="client/src/pages/Team.jsx" data-component-line="17:13" data-component-id="client/src/pages/Team.jsx:17:13" className="space-y-3 mb-4">
                    <div data-component-path="client/src/pages/Team.jsx" data-component-line="18:15" data-component-id="client/src/pages/Team.jsx:18:15" className="flex items-start gap-3">
                      <Award data-component-path="client/src/pages/Team.jsx" data-component-line="19:17" data-component-id="client/src/pages/Team.jsx:19:17" className="w-5 h-5 text-amber-600 flex-shrink-0 mt-1" />
                      <div data-component-path="client/src/pages/Team.jsx" data-component-line="20:17" data-component-id="client/src/pages/Team.jsx:20:17">
                        <p data-component-path="client/src/pages/Team.jsx" data-component-line="21:19" data-component-id="client/src/pages/Team.jsx:21:19" className="text-xs text-gray-500 mb-1">Specialization</p>
                        <p data-component-path="client/src/pages/Team.jsx" data-component-line="22:19" data-component-id="client/src/pages/Team.jsx:22:19" className="text-sm font-medium text-gray-900">{member.specialization}</p>
                      </div>
                    </div>
                    <div data-component-path="client/src/pages/Team.jsx" data-component-line="23:15" data-component-id="client/src/pages/Team.jsx:23:15" className="flex items-start gap-3">
                      <Briefcase data-component-path="client/src/pages/Team.jsx" data-component-line="24:17" data-component-id="client/src/pages/Team.jsx:24:17" className="w-5 h-5 text-amber-600 flex-shrink-0 mt-1" />
                      <div data-component-path="client/src/pages/Team.jsx" data-component-line="25:17" data-component-id="client/src/pages/Team.jsx:25:17">
                        <p data-component-path="client/src/pages/Team.jsx" data-component-line="26:19" data-component-id="client/src/pages/Team.jsx:26:19" className="text-xs text-gray-500 mb-1">Experience</p>
                        <p data-component-path="client/src/pages/Team.jsx" data-component-line="27:19" data-component-id="client/src/pages/Team.jsx:27:19" className="text-sm font-medium text-gray-900">{member.experience}</p>
                      </div>
                    </div>
                  </div>

                  <div data-component-path="client/src/pages/Team.jsx" data-component-line="28:13" data-component-id="client/src/pages/Team.jsx:28:13" className="flex items-center gap-3 pt-4 border-t border-gray-200">
                    <a data-component-path="client/src/pages/Team.jsx" data-component-line="29:15" data-component-id="client/src/pages/Team.jsx:29:15"
                      href={`mailto:${member.email}`}
                      className="flex items-center gap-2 text-sm text-gray-600 hover:text-amber-600 transition-colors"
                    >
                      <Mail data-component-path="client/src/pages/Team.jsx" data-component-line="30:17" data-component-id="client/src/pages/Team.jsx:30:17" className="w-4 h-4 flex-shrink-0" />
                      <span data-component-path="client/src/pages/Team.jsx" data-component-line="31:17" data-component-id="client/src/pages/Team.jsx:31:17">Email</span>
                    </a>
                    <a data-component-path="client/src/pages/Team.jsx" data-component-line="32:15" data-component-id="client/src/pages/Team.jsx:32:15"
                      href={member.linkedin}
                      className="flex items-center gap-2 text-sm text-gray-600 hover:text-amber-600 transition-colors"
                    >
                      <Linkedin data-component-path="client/src/pages/Team.jsx" data-component-line="33:17" data-component-id="client/src/pages/Team.jsx:33:17" className="w-4 h-4 flex-shrink-0" />
                      <span data-component-path="client/src/pages/Team.jsx" data-component-line="34:17" data-component-id="client/src/pages/Team.jsx:34:17">LinkedIn</span>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Team